export type MergeProvenanceComponent = {
  label: string;
  tag_display_name: string | null;
};

export type MergeProvenanceV1 = {
  v: 1;
  components: MergeProvenanceComponent[];
};

function isMergeProvenanceJson(raw: string | null | undefined): boolean {
  if (raw == null) return false;
  const t = raw.trim();
  return t.startsWith("{") && t.endsWith("}");
}

export function hasMergeProvenanceBlob(raw: string | null | undefined): boolean {
  return isMergeProvenanceJson(raw);
}

export function parseMergeProvenance(raw: string | null | undefined): MergeProvenanceV1 | null {
  if (!raw?.trim() || !isMergeProvenanceJson(raw)) return null;
  try {
    const parsed: unknown = JSON.parse(raw);
    if (
      typeof parsed !== "object" ||
      parsed === null ||
      (parsed as MergeProvenanceV1).v !== 1 ||
      !Array.isArray((parsed as MergeProvenanceV1).components)
    ) {
      return null;
    }
    const components = (parsed as MergeProvenanceV1).components
      .filter(
        (c): c is MergeProvenanceComponent =>
          typeof c === "object" &&
          c !== null &&
          typeof (c as MergeProvenanceComponent).label === "string" &&
          (c as MergeProvenanceComponent).label.trim().length > 0
      )
      .map((c) => {
        const rawDisplay = (c as MergeProvenanceComponent).tag_display_name;
        const tag_display_name =
          rawDisplay == null || String(rawDisplay).trim() === "" ? null : String(rawDisplay);
        return { label: (c as MergeProvenanceComponent).label.trim(), tag_display_name };
      });
    if (components.length < 2) return null;
    return { v: 1, components };
  } catch {
    return null;
  }
}

export function formatMergedComponentList(components: MergeProvenanceComponent[]): string {
  return components
    .map((c) => (c.tag_display_name?.trim() ? c.tag_display_name.trim() : c.label))
    .join(", ");
}

export function mergedTagClusterDisplayLabel(
  tag_merged_label: string | null | undefined,
  fallbackName: string
): string {
  const prov = parseMergeProvenance(tag_merged_label);
  if (prov) {
    return formatMergedComponentList(prov.components);
  }
  const trimmed = tag_merged_label?.trim();
  if (trimmed && !hasMergeProvenanceBlob(trimmed)) {
    return trimmed;
  }
  return fallbackName;
}
